import { ServiceDefinition } from '@pershing/pershing-core';
import { BalancesConstants } from './../../utils/balances/balances-constants';

// Singleton class
export class BalancesServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri = 'balances';
    version = 'v1';

    family = 'netx360';
    appName = 'balances-svc';
    serviceName = 'app';
    mnemonic = 'nxp';

    static getInstance(platform: string): ServiceDefinition {
        if (!BalancesServiceDefinition.instance) {
            BalancesServiceDefinition.instance = new BalancesServiceDefinition();
            if (platform === 'retail') {
                BalancesServiceDefinition.instance.family = 'netxinvestor';
                BalancesServiceDefinition.instance.mnemonic = 'nxc';
            }
        }
        return BalancesServiceDefinition.instance;
    }

    static getBalancesResourceURL(baseUrl: string, context: string, contextValue: string, quoteType?: string) {
        switch (context) {
            case 'account': {
                context = 'accounts';
                break;
            }
            case 'client': {
                context = 'clients';
                break;
            }
            case 'household': {
                context = 'households';
                break;
            }
            case 'group': {
                context = 'groups';
                break;
            }
            default: {
                break;
            }
        }
        quoteType = quoteType ? quoteType : BalancesConstants.DELAYED;
        return `${baseUrl}/${context}/${contextValue}?quoteType=${quoteType}`;
    }
   
    private constructor() {
        //intentional empty constructor
    }
}
